
  export default {
    props: {
      dataSet: { type: Object, default () { return {}; } },
      discount: { type: String, default: null }
    }
  };
